import { ISbStoryData } from '@storyblok/js';
import { ISbComponentType } from 'storyblok-js-client';
import { Components } from './components';

const getAllRelationships = (body: ISbComponentType<string>[], ids: string[] = []) => {
  body.forEach(block => {
    if (!block) return;
    for (const key in block) {
      if (['id', 'uid', 'uuid', '_uid', '_uuid'].includes(key)) continue;
      if (!block[key]) continue;
      if (typeof block[key] === 'string') {
        if (block[key].match(/^[0-9a-f]{8}-([0-9a-f]{4}-){3}[0-9a-f]{12}$/)) {
          ids.push(block[key]);
        }
      } else if (Array.isArray(block[key])) {
        if (typeof block[key][0] === 'string') {
          if (block[key][0]?.match(/^[0-9a-f]{8}-([0-9a-f]{4}-){3}[0-9a-f]{12}$/)) {
            ids.push(...block[key]);
          }
        } else {
          getAllRelationships(block[key], ids);
        }
      }
    }
  });
  return ids;
};

const containsComponentSingle = (item: ISbStoryData['content'], type: keyof typeof Components) => {
  if (item.component === type) return true;
  for (const key in item) {
    if (['id', 'uid', 'uuid', '_uid', '_uuid'].includes(key)) continue;
    if (!item[key]) continue;
    if (typeof item[key] === 'string') continue;
    if (Array.isArray(item[key])) {
      if (containsComponent(item[key], type)) return true;
    }
    if (containsComponentSingle(item[key], type)) return true;
  }
};

export const containsComponent = (items: ISbStoryData['content'][], type: keyof typeof Components): boolean => {
  return items.some(item => containsComponentSingle(item, type));
};

export const getRelationships = (story: ISbStoryData) => {
  return getAllRelationships([story.content]);
};
